var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfSellCarLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202,
    height: 2,
    viewBox: "0 0 202 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21799",
    "data-name": "\\uADF8\\uB8F9 21799",
    transform: "translate(-491 -441)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_221",
    "data-name": "\\uD0C0\\uC6D0 221",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(555 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1232",
    "data-name": "\\uD0C0\\uC6D0 1232",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(603 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1253",
    "data-name": "\\uD0C0\\uC6D0 1253",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(643 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_222",
    "data-name": "\\uD0C0\\uC6D0 222",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(563 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1233",
    "data-name": "\\uD0C0\\uC6D0 1233",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(611 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1254",
    "data-name": "\\uD0C0\\uC6D0 1254",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(651 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1238",
    "data-name": "\\uD0C0\\uC6D0 1238",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(619 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1255",
    "data-name": "\\uD0C0\\uC6D0 1255",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(659 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1239",
    "data-name": "\\uD0C0\\uC6D0 1239",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(627 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1256",
    "data-name": "\\uD0C0\\uC6D0 1256",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(667 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1258",
    "data-name": "\\uD0C0\\uC6D0 1258",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(683 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1240",
    "data-name": "\\uD0C0\\uC6D0 1240",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(635 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1257",
    "data-name": "\\uD0C0\\uC6D0 1257",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(675 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1259",
    "data-name": "\\uD0C0\\uC6D0 1259",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(691 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_220",
    "data-name": "\\uD0C0\\uC6D0 220",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(547 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1234",
    "data-name": "\\uD0C0\\uC6D0 1234",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(595 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_220-2",
    "data-name": "\\uD0C0\\uC6D0 220",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(539 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1235",
    "data-name": "\\uD0C0\\uC6D0 1235",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(587 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_220-3",
    "data-name": "\\uD0C0\\uC6D0 220",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(531 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1236",
    "data-name": "\\uD0C0\\uC6D0 1236",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(579 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_220-4",
    "data-name": "\\uD0C0\\uC6D0 220",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(523 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1237",
    "data-name": "\\uD0C0\\uC6D0 1237",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(571 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_220-5",
    "data-name": "\\uD0C0\\uC6D0 220",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(515 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_220-6",
    "data-name": "\\uD0C0\\uC6D0 220",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(507 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_220-7",
    "data-name": "\\uD0C0\\uC6D0 220",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(499 441)",
    fill: "#ff6a13"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_220-8",
    "data-name": "\\uD0C0\\uC6D0 220",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(491 441)",
    fill: "#ff6a13"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfSellCarLine);
export default __webpack_public_path__ + "static/media/SelfSellCarLine.fbe32b4c69d7cabd467af9c1ab59de8d.svg";
export { ForwardRef as ReactComponent };